import React, { useEffect } from 'react'

// function useTitle() {
//   useEffect(() => {    
    
//   });
// }

const Repeat = props => {
  let items = []
  for (let index = 0; index < props.numTimes; index++) {
    items.push(props.children(index))
  }
  return <div>{items}</div>
},

jsxInDepth = () => { 

  document.title = "JavaScript Extended (JSX) syntax - React";

  return (
    <Repeat numTimes={10} >
      {(index) => <div key={index}>This is item {index} in the list</div>}
    </Repeat>
  )  
}

export default jsxInDepth